import { clearClickedMcBimItemIdInRedux } from "../../ViewerRedux/viewerSlice";
import { setActiveLeftSideBarTabInRedux } from "../../DesignTab/designSlice";
import React, { useState } from "react";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { rSetAgGridState, selectAgGridStateByKey } from "../../agGridStateSlice";
import { selectMcBimItemFlatRows } from "./singleMcbimItemSelectors";
import { DrofusMatch } from "../../DrofusMatch/DrofusMatch";
import { MmiSingleItem } from "./MMISingleItem";
import { ObjectDetailsPanel } from "./ObjectDetailsPanel";

export const McBimItemDetailsTable: React.FC = () => {
  const rows = useAppSelector(selectMcBimItemFlatRows);
  const saved = useAppSelector(selectAgGridStateByKey("mcBimDetailsTable"));
  const [search, setSearch] = useState(saved?.quickFilter ?? "");
  const dispatch = useAppDispatch();
  const close = () => {
    dispatch(clearClickedMcBimItemIdInRedux());
    dispatch(setActiveLeftSideBarTabInRedux(undefined));
  };
  return <ObjectDetailsPanel additionalSections={<DrofusMatch />} onClose={close} rows={rows} search={search} onSearch={value => { setSearch(value); dispatch(rSetAgGridState({ key: "mcBimDetailsTable", data: { quickFilter: value } })); }} mmi={<MmiSingleItem />} />;
};
